import React from 'react'
import { withContentful } from 'components/vendor/Contentful/withContentful'
import { CONTENTFUL_KEYS, EMBED_PARTNERS, EMBED_PRODUCTS } from 'parameters'
import MultiProductWidget from 'components/vendor/MultiProductWidget/MultiProductWidget'
import ProductPageLayout from './common/ProductPageLayout'
import { ExplorePageReduxProps } from 'types/page'

const StudentLoanRefinancePage = ({ articles, getValue }: ExplorePageReduxProps): JSX.Element => (
	<ProductPageLayout
		articles={articles}
		title={
			<h1>
				{getValue(CONTENTFUL_KEYS.PRODUCTS.STUDENT_LOAN_REFINANCE.TITLE.FIRST)}{' '}
				<strong>{getValue(CONTENTFUL_KEYS.PRODUCTS.STUDENT_LOAN_REFINANCE.TITLE.SECOND)}</strong>
			</h1>
		}
		description={getValue(CONTENTFUL_KEYS.PRODUCTS.STUDENT_LOAN_REFINANCE.DESCRIPTION)}
	>
		<MultiProductWidget step={'application'} product={EMBED_PRODUCTS.LOAN} partner={EMBED_PARTNERS.FIONA_SLR} />
	</ProductPageLayout>
)

export default withContentful(StudentLoanRefinancePage)
